import {
  IPaymentMethodResp,
  PaymentMethodStatusEnum,
} from '@monetize/types/app';
import { FunctionComponent as FC } from 'react';
import { MFormField, MGridItem, MText } from '../../../components/Monetize';

import { DateDisplay } from '../../../components/Monetize/DateDisplay';

interface PaymentMethodCancellationReasonDisplayProps {
  paymentMethod: IPaymentMethodResp;
}

export const PaymentMethodCancellationReasonDisplay: FC<
  PaymentMethodCancellationReasonDisplayProps
> = ({ paymentMethod }) => {
  if (paymentMethod.status !== PaymentMethodStatusEnum.CANCELED) {
    return null;
  }

  return (
    <>
      {paymentMethod.cancellationReason && (
        <MGridItem colSpan={6}>
          <MFormField label="Cancellation Reason" isReadOnly>
            <MText mt="1">{paymentMethod.cancellationReason}</MText>
          </MFormField>
        </MGridItem>
      )}

      {paymentMethod.cancellationDate && (
        <MGridItem colSpan={6}>
          <MFormField label="Cancellation Date" isReadOnly>
            <DateDisplay
              date={paymentMethod.cancellationDate}
              timezoneConfigKey="userTimezone"
              textProps={{ mt: '1' }}
            />
          </MFormField>
        </MGridItem>
      )}
    </>
  );
};
